import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useDevice } from 'components/DeviceContext.js';
import { Grid } from '@mui/material';
import styles from './CabecalhoLink.module.css';

// Styled component for MenuItem
const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  '& .MuiSvgIcon-root': {
    fontSize: 18,
    color: theme.palette.text.secondary,
    marginRight: theme.spacing(1.5),
  },
}));

const LinksCabecalho = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const { isMobile, isLaptop, isDesktop } = useDevice();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const links = [
    { text: 'Início', url: './' },
    { text: 'Notícias', url: './noticias' },
    {
      text: 'Mapas',
      url: '#',
      submenus: [
        { text: 'Mapa Geral', url: './mapa-crack' },
        { text: 'Mapa fronteiras', url: './mapa-fronteiras' },
        { text: 'Mapa Assistência', url: './mapa-assistencia' },
      ],
    },
    { text: 'Legislação', url: './legislacao' },
    { text: 'Biblioteca', url: './biblioteca' },
    { text: 'Boas Práticas', url: './boas-praticas' },
    { text: 'Contatos', url: './contatos' },
  ];

  return (
    <Grid container alignItems="center">
      {links.map((link, index) => (
        <Grid
          key={index}
          item
          style={{
            marginRight: isLaptop || isDesktop ? 0 : '0.3em',
            marginTop: isLaptop || isDesktop ? '0' : '0.2em'
          }}
        >
          {link.submenus ? (
            <div>
              <Link
                aria-controls={anchorEl ? 'menu-list' : undefined}
                aria-haspopup="true"
                onClick={handleClick}
                style={{
                  color: isMobile ? 'var(--preto)' : 'var(--branco)',
                  fontSize: isLaptop ? '16px' : isMobile ? '18px' : '20px',
                  lineHeight: isLaptop ? '24px' : 'normal',
                  display: 'flex',
                  alignItems: 'center',
                }}
                to={link.url}
                className={styles.link}
              >
                {link.text} <KeyboardArrowDownIcon />
              </Link>
              <Menu
                id="menu-list"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                MenuListProps={{
                  'aria-labelledby': 'basic-button',
                }}
              >
                {link.submenus.map((submenu, idx) => (
                  <StyledMenuItem key={idx} onClick={handleClose}>
                    <Link to={submenu.url}>{submenu.text}</Link>
                  </StyledMenuItem>
                ))}
              </Menu>
            </div>
          ) : (
            <Link
              className={styles.link}
              style={{
                color: isMobile ? 'var(--preto)' : 'var(--branco)',
                fontSize: isLaptop ? '16px' : isMobile ? '18px' : '20px',
                lineHeight: isLaptop ? '24px' : 'normal',
                display: 'flex',
                alignItems: 'center',
              }}
              to={link.url}
            >
              {link.text}
            </Link>
          )}
        </Grid>
      ))}
      {/* <Link to="login">
        <span
          style={{
            borderRadius: '8px',
            border: '1px solid var(--branco)',
            color: 'var(--branco)',
            padding: '8px',
            textDecoration: 'none',
            fontSize: '20px',
            marginLeft: isDesktop ? '2em': '',
          }}
        >
          Login
        </span>
      </Link> */}
    </Grid>
  );
};

export default LinksCabecalho;
